import { RestfulModel } from 'app/model/restful-model';
import { DateString, ModelWithoutId } from 'app/type';

export interface StoreKeyword extends RestfulModel {
    keyword: string;
    active: boolean;
    nameKeyword: boolean;
    dateCreated?: DateString;
    dateEdited?: DateString;
}

export const createNewKeyword = (): ModelWithoutId<StoreKeyword> => ({
    keyword: '',
    active: true,
    nameKeyword: false,
});
